export const setupList = [
    { name: "Payroll Location", value: "payLoc" },
    { name: "Timekeep Group", value: "tkGrp" },
    { name: "Pagibig", value: "pagibig" },
    { name: "Movement Type Details", value: "mtd" },
    { name: "Earnings", value: "earn" },
    { name: "Deductions", value: "deduc" },
    { name: "Area", value: "area" },
    { name: "Pay House", value: "ph" },
    { name: "Branch", value: "bra" },
    { name: "Department", value: "dep" },
    { name: "Division", value: "div" },
    { name: "Group", value: "grp" },
    { name: "Location", value: "loc" },
    { name: "Section", value: "sec" },
    { name: "Unit", value: "unit" },
    { name: "Designation", value: "des" },
    { name: "Job Level", value: "jl" },
    { name: "Employee Status", value: "empStat" },
    { name: "Employee Category", value: "empCat" },
    { name: "Employee Classification", value: "empClass" },
    { name: "Designation Duties and Responsibilities", value: "desDuRes" },
    { name: "Rank", value: "rank" },
    { name: "Grade", value: "grade" },
    { name: "Step", value: "step" },
    { name: "Specialization", value: "spec" },
    { name: "Province", value: "prov" },
    { name: "Residence Type", value: "resType" },
    { name: "Religion", value: "rel" },
    { name: "Disciplinary Case - Classification", value: "dcClass" },
    { name: "Disciplinary Case - Main Article", value: "dcMainArt" },
    { name: "Disciplinary Case - Sub Article", value: "dcSubArt" },
    { name: "Disciplinary Case - Specific Type", value: "dcSpecType" },
    { name: "Disciplinary Case - Action", value: "dcAction" },
    { name: "Course/Degree", value: "course" },
    { name: "Educational Attainment", value: "eduAtt" },
    { name: "Major", value: "major" },
    { name: "School", value: "school" },
    { name: "Course And Seminar Title", value: "courseSem" },
    { name: "Seminar Classification", value: "semClass" },
    { name: "Seminar Classification Signatories", value: "semClassSig" },
    { name: "Seminar Type", value: "semType" },
    { name: "Accredited Body", value: "accreBody" },
    { name: "Annual Physical Examination", value: "ape" },
    { name: "Awards and Commendations", value: "awardComm" },
    { name: "Signatory Type", value: "sigType" },
    { name: "Document Submitted", value: "docSub" },
    { name: "Duties and Responsibilities", value: "dutRes" },
    { name: "Exam Type", value: "examType" },
    { name: "Field of Interest", value: "foi" },
    { name: "Government Exam", value: "govExam" },
    { name: "Government Forms", value: "govForms" },
    { name: "Health Insurance", value: "healthIns" },
    { name: "Job Requirements", value: "jobReq" },
    { name: "Licenses", value: "lic" },
    { name: "Insurance Claim", value: "insClaim" },
    { name: "Medical Cases", value: "medCase" },
    { name: "Overseas Placement Status", value: "overseas" },
    { name: "Benefit", value: "benefit" },
    { name: "Medical Reimbursements", value: "medReim" },
    { name: "Project File", value: "projFile" },
    { name: "Project Details", value: "projD" },
    { name: "Skills", value: "skills" },
    { name: "Online Approval", value: "onlineApp" },
    /*RLV:06Jul2022*/
    { name: "ES Grouping", value: "esgrouping" }, 
    { name: "Holiday Calendar ID", value: "holiCalendar" },
    { name: "PS Grouping", value: "psgrouping" }
]